import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-navy py-24 px-6 relative" data-id="element-155">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-5" data-id="element-156"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-gradient-to-br from-navy-light to-navy border border-gold/30 rounded-3xl p-8 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-158">
          {/* Decorative corner elements */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-gold/10 rounded-br-full blur-2xl" data-id="element-159"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-gold/10 rounded-tl-full blur-2xl" data-id="element-160"></div>

          <div className="text-center mb-10" data-id="element-161">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 mb-6 border border-gold/30" data-id="element-162">
              <ShieldCheck className="w-8 h-8 text-gold" data-id="element-163" />
            </div>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-cream mb-4" data-id="element-164">
              El Protocolo de Transferencia Táctica (PTT)
            </h2>
            <p className="text-xl text-gold font-medium italic" data-id="element-165">
              Este no es un manual de entrenamiento militar, es un hack
              biológico.
            </p>
          </div>

          <div className="space-y-6 text-lg text-cream/90 leading-relaxed" data-id="element-166">
            <p data-id="element-167">
              El PTT utiliza la presión sensorial y el control de temperatura
              para que el sistema nervioso de tu bebé no detecte que ha dejado
              de estar en tus brazos.
            </p>
            <div className="bg-navy-dark/50 p-6 rounded-xl border-l-4 border-gold" data-id="element-168">
              <p data-id="element-169">
                Mediante la técnica de{' '}
                <strong className="text-gold" data-id="element-170">"Lado-Espalda"</strong> y el uso
                de la <strong className="text-gold" data-id="element-171">"Mano de Presión"</strong>,
                logramos una transición invisible que mantiene al bebé en sueño
                profundo mientras tú sales de la habitación para finalmente
                descansar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}